import { useState } from 'react';
import { useCreatorMe } from '../../../lib/auth';
import styles from './Hub.module.css';

const INTAKE_ROUTES: Record<string, { url: string; label: string; instruction: string }> = {
  beta: {
    url: 'https://www.gokick.com/visits/pac/signup/',
    label: 'Beta Blocker',
    instruction:
      'When selecting your format, Beta Blocker Mints are available for delivery (arrives in a couple of days) and Beta Blocker Tablets are available for local pharmacy pickup, often same-day.',
  },
  sleep: {
    url: 'https://www.gokick.com/visits/inc/signup/',
    label: 'Rx Sleep Plan',
    instruction:
      'When selecting your format, Prescription Sleep Gummies are available for delivery and Prescription Sleep Tablets are available for local pharmacy pickup.',
  },
};

const GENERAL =
  'You will go through an approximately 15 minute online medical intake for prescription medication. Please answer all questions truthfully. At the end of the intake you will be prompted to enter your one-time unique code, which also covers the cost of your medication.';

function productType(p: string | string[] | undefined): 'beta' | 'sleep' | null {
  const joined = ([] as string[]).concat(p ?? []).join(' ').toLowerCase();
  if (joined.includes('beta')) return 'beta';
  if (joined.includes('sleep')) return 'sleep';
  return null;
}

export function MedicalIntakeView() {
  const { data } = useCreatorMe();
  const [copied, setCopied] = useState(false);
  if (!data) return null;

  // Demo: hub showed intake even before contract; preserve that.
  const route = INTAKE_ROUTES[productType(data.submission?.productInterest) ?? ''] ?? null;
  const code = data.intakeCode || 'DEMO-CODE';
  const btnLabel = route?.label ? `Start My ${route.label} Intake` : 'Start My Intake';

  function copyCode() {
    navigator.clipboard.writeText(code).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  }

  return (
    <>
      <div className={styles.pageActionRow} style={{ marginBottom: 20 }}>
        <div>
          <div className={styles.pageTitle}>Medical Intake</div>
          <div className={styles.pageSubtitle}>
            Complete your online medical intake to receive your product.
          </div>
        </div>
        <span className={`${styles.badge} ${styles.badgeGreen}`}>Available</span>
      </div>
      <div className={styles.card}>
        <div className={styles.cardHead}>
          <div className={styles.cardSectionTitle}>Before you begin</div>
        </div>
        <div className={styles.cardBody}>
          <div className={styles.intakeInstr}>{GENERAL}</div>
        </div>
      </div>
      {route?.instruction && (
        <div className={styles.card}>
          <div className={styles.cardHead}>
            <div className={styles.cardSectionTitle}>Format selection</div>
          </div>
          <div className={styles.cardBody}>
            <div className={styles.intakeInstr}>{route.instruction}</div>
          </div>
        </div>
      )}
      <div className={styles.card}>
        <div className={styles.intakeCodeArea}>
          <div className={styles.codeEyebrow}>Your one-time intake code</div>
          <div className={styles.codeDisplay}>{code}</div>
          <div style={{ marginTop: 10 }}>
            <button type="button" className={styles.btnSecondary} onClick={copyCode}>
              Copy code
            </button>
            <div className={styles.copyConfirm}>{copied ? 'Copied!' : ''}</div>
          </div>
          <div className={styles.intakeCtaRow}>
            {route ? (
              <a
                className={styles.btnPrimary}
                href={route.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                {btnLabel} &nbsp;→
              </a>
            ) : (
              <>
                <span
                  className={styles.btnPrimary}
                  style={{ opacity: 0.5, pointerEvents: 'none' }}
                >
                  {btnLabel}
                </span>
                <div className={styles.intakeNoRoute}>
                  Your intake link will appear here once your product selection is confirmed.
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
